import { GameID, PlayerID } from "@kosmod/sesame"
import { ID, idDef } from "@kosmod/kit"
import { DiceExpression, DiceResult, DiceTemplateID, Die } from "@kosmod/andy"
import { s } from "@kosmod/pancake"
import { TheatreMatrix4 } from "./position"
import { K3D } from "@kosmod/graphics-3d"

/**
 * A Physics die is something that is rolled
 */

export type PhysicsDiceID = ID<'theatre-physics-die'>
export type PhysicsDice = {
  id: PhysicsDiceID,
  dieTemplate: DiceTemplateID,

  result: null | DiceResult,

  /**
   * Only a single player is responsible for simulating
   * the dice (typically the person that "rolls" the die).
   * 
   * Everyone else in the theatre just listens to transform updates
   * from them.
   */
  simulator: PlayerID,

  initialTransform: K3D.Transform
}

export const PhysicsDiceID = idDef;
export const PhysicsDice = s.ref<PhysicsDice>()(s.o({
  id: PhysicsDiceID,
  dieTemplate: DiceTemplateID,
  result: s.optional(DiceResult),
  simulator: PlayerID,
  initialTransform: K3D.Transform
}));